import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import {AdEditorGuard} from "./_core/guards/ad-editor.guard";
import { ContentPageResolver } from './_core/resolvers/content-page.resolver';
import { DynamicContentPageComponent } from './pages/dynamic-content-page/dynamic-content-page.component';
import { NotFoundComponent } from './pages/not-found/not-found.component';

const routes: Routes = [
	{ path: '', loadChildren: () => import('./pages/projects/projects.module').then(m => m.ProjectsPageModule) },
	{ path: 'login', data: { animationKey: 'login' }, loadChildren: () => import('./pages/auth/auth.module').then(m => m.AuthPageModule) },
	{
		path: 'signup',
		data: { animationKey: 'signup' },
		loadChildren: () => import('./pages/auth/auth.module').then(m => m.AuthPageModule)
	},
	{
		path: 'create-business',
		data: { animationKey: 'create-business' },
		loadChildren: () => import('./pages/auth/auth.module').then(m => m.AuthPageModule)
	},
	{
		path: 'join-business',
		data: { animationKey: 'join-business' },
		loadChildren: () => import('./pages/auth/auth.module').then(m => m.AuthPageModule)
	},
	{
		path: 'business-subscription/:id',
		data: { animationKey: 'business-subscription' },
		loadChildren: () => import('./pages/auth/auth.module').then(m => m.AuthPageModule)
	},//
	{
		path: 'business-trial/:id',
		data: { animationKey: 'business-trial' },
		loadChildren: () => import('./pages/auth/auth.module').then(m => m.AuthPageModule)
	},
	{
		path: 'validate-subscription/:id',
		data: { animationKey: 'validate-subscription' },
		loadChildren: () => import('./pages/auth/auth.module').then(m => m.AuthPageModule)
	},
	{
		path: 'setup-subscription/:id',
		data: { animationKey: 'setup-subscription' },
		loadChildren: () => import('./pages/auth/auth.module').then(m => m.AuthPageModule)
	},
	{ path: 'dashboard', loadChildren: () => import('./pages/projects/projects.module').then(m => m.ProjectsPageModule) },
	{ path: 'project', redirectTo: '', pathMatch: 'full' },
	{ path: 'project/:id', loadChildren: () => import('./pages/project/project.module').then(m => m.ProjectPageModule) },
	{ path: 'review/:id', loadChildren: () => import('./pages/project/project.module').then(m => m.ProjectPageModule) },
	{ path: 'admin', loadChildren: () => import('./pages/admin/admin.module').then(m => m.AdminPageModule) },
	{ path: 'settings', loadChildren: () => import('./pages/settings/settings.module').then(m => m.SettingsPageModule) },
	{ path: 'share', loadChildren: () => import('./pages/share/share.module').then(m => m.ShareModule) },
	{ path: 'creator', loadChildren: () => import('./pages/creator/creator.module').then(m => m.CreatorPageModule) },
	{ path: 'onboard/external-payment-method', redirectTo: '/?onboard=external-payment-method', pathMatch: 'full' },
	{
		path: 'ad-editor',
		loadChildren: () => import('./pages/sandbox/ad-editor/ad-editor.module').then(m => m.AdEditorPageModule),
		canActivate: [AdEditorGuard]
	},
	{
		path: 'sandbox/ad-editor',
		loadChildren: () => import('./pages/sandbox/ad-editor/ad-editor.module').then(m => m.AdEditorPageModule),
		canActivate: [AdEditorGuard]
	},
	{
		path: 'sandbox/ad-editor/:id',
		loadChildren: () => import('./pages/sandbox/ad-editor/ad-editor.module').then(m => m.AdEditorPageModule),
		canActivate: [AdEditorGuard]
  },
  {
    path: 'sandbox/creative-unit-chat',
    loadChildren: () => import('./pages/sandbox/creative-unit-chat/creative-unit-chat.module').then(m => m.CreativeUnitChatPageModule),
    canActivate: [AdEditorGuard]
  },
  {
    path: 'sandbox/ai',
    loadChildren: () => import('./pages/sandbox/ai/ai-sandbox.module').then(m => m.AiSandboxPageModule),
    canActivate: [AdEditorGuard]
  },
  {
    path: 'sandbox/creative-x',
    loadChildren: () => import('./pages/sandbox/creative-x/creative-x-sandbox.module').then(m => m.CreativeXSandboxModule),
    canActivate: [AdEditorGuard]
  },
  {
    path: 'sandbox/scripts',
    loadChildren: () => import('./pages/sandbox/scripts/sandbox.module').then(m => m.SandboxModule),
    canActivate: [AdEditorGuard]
  },
  {
    path: 'editor/preview/:id',
    loadChildren: () => import('./pages/sandbox/ad-editor-preview/ad-editor-preview.module').then(m => m.AdEditorPreviewPageModule),
    canActivate: [AdEditorGuard]
  },
	{
		path: 'sandbox/ad-generation',
		loadChildren: () => import('./pages/sandbox/ad-generation/ad-generation.module').then(m => m.AdGenerationPageModule),
		canActivate: [AdEditorGuard]
	},
	{
		path: 'sandbox/merge-tags-test',
		loadChildren: () => import('./pages/sandbox/merge-tags-test/merge-tags-test.module').then(m => m.MergeTagsTestModule)
	},
	{
		path: 'editor/preview/:id',
		loadChildren: () => import('./pages/sandbox/ad-editor-preview/ad-editor-preview.module').then(m => m.AdEditorPreviewPageModule),
		canActivate: [AdEditorGuard]
	},
	{
		path: 'sandbox/figma-import',
		loadChildren: () => import('./pages/sandbox/figma-import/figma-import.module').then(m => m.FigmaImportPageModule),
		canActivate: [AdEditorGuard]
	},
	{
		path: 'sandbox/figma-import/callback',
		loadChildren: () => import('./pages/figma/callback/figma-callback.module').then(m => m.FigmaCallbackModule)
	},
	{
		path: 'sandbox/figma-import-studio',
		loadChildren: () => import('./pages/sandbox/figma-import/figma-import-studio.module').then(m => m.FigmaImportStudioModule),
		canActivate: [AdEditorGuard]
	},
	{
		path: 'sandbox/input-tests',
		loadChildren: () => import('./pages/sandbox/input-tests/input-tests.module').then(m => m.InputTestsPageModule)
	},
	{
		path: 'sandbox/focal-area-cropping',
		loadChildren: () => import('./pages/sandbox/focal-area-cropping/focal-area-cropping-sandbox.module').then(m => m.FocalAreaCroppingSandboxPageModule)
	},
	{
		path: 'sandbox/package-api',
		loadChildren: () => import('./pages/sandbox/package-api/package-api.module').then(m => m.PackageApiPageModule),
		canActivate: [AdEditorGuard]
	},
	{
		path: 'editor',
		loadChildren: () => import('./pages/sandbox/ad-editor/ad-editor.module').then(m => m.AdEditorPageModule),
		canActivate: [AdEditorGuard]
	},
	{
		path: 'editor/:id/:creativeUnitId',
		loadChildren: () => import('./pages/sandbox/ad-editor/ad-editor.module').then(m => m.AdEditorPageModule),
		canActivate: [AdEditorGuard]
	},
	// 404 route - must come before wildcard
	{ path: '404', component: NotFoundComponent },
	// Wildcard route for dynamic content pages - must be last
	{
		path: '**',
		component: DynamicContentPageComponent,
		resolve: { page: ContentPageResolver },
		data: { dynamic: true }
	}
];

@NgModule({
	imports: [RouterModule.forRoot(routes, { scrollOffset: [0, 0], scrollPositionRestoration: 'enabled' })],
	exports: [RouterModule]
})
export class AppRoutingModule {}
